import Repository from './repository';

/**
   * Constructor
   */
const url = 'surveys';

const Survey = {
  /**
   * Get All survey
   */
  getAll: () => Repository.get(url),

  /**
   * Get survey by id, slug
   * @param {Number} id
   */
  getSurveyById: path => Repository.get(`${url}/${path}`),

  /**
   * Get result by id
   * @param {Number} id
   */
  getResultById: (id) => Repository.get(`${url}/GetSurveyResult?survey_result_id=${id}`),

  /**
   * Submit the survey
   * @param {Object} payload
   */
  submit: payload => Repository.post(`${url}/submitResult`, payload),

  /**
   * Get footer info
   */
  getFooter: () => Repository.get('footer'),

  getResults: (userId) => Repository.get(`${url}/GetAllResultSurveyByUserId?user_id=${userId}`)
};

export default Survey;
